
import React from 'react';
import Commonsection from './../component/UI/Common-section/Commonsection';
import { Container , Row , Col } from 'reactstrap';
import '../Styles/wallet.css';

function  Wallet ()  {

    const  wallet__data  = [
        {
            title : "Bitcoin",
            desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint." ,
            icon: "ri-bit-coin-line"
        },
        {
            title : "Coinbaser",
            desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint." ,
            icon: "ri-coin-line" 
        },
        {
            title : "Meteamask",
            desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint." ,
            icon: "ri-money-cny-circle-line"
        },
        {
            title : "Authereum",
            desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint." ,
            icon: "ri-bit-coin-line"
        },
    ];


    return(

        <>
            <Commonsection  title='connect Wallet'  />
            <section>
                <Container >
                    <Row>
                        <Col  className='mb-5  text-center'  lg="12"  md="12"  sm="12">
                            <div  className='w-100   wallet-all-desc  '>
                                <h3 className='text-light  mb-4'> Connect Your Wallet </h3>
                                <p >  
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.
                                </p>
                            </div>
                            <br />
                        </Col>
                        <br />

                        {
                            wallet__data.map((item , index) => {
                                return(
                                    <Col  className='mb-4' lg="3"   md="4"   sm="6"  key={index}>
                                    <div  className='wallet__item'>
                                        <span>  <i class={item.icon}>  </i>  </span>
                                        <h5> {item.title} </h5>
                                        <p >  
                                            {item.desc}
                                        </p>
                                    </div>
                                </Col>

                                )
                            })
                        }

                    </Row>

                </Container>
            </section>


        </>
    );
}

export default Wallet;
